var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHelpline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 4a6 6 0 0 1 5.659 4h2.089A8.003 8.003 0 0 0 4.252 8h2.09C7.164 5.67 9.387 4 12 4M2 9h4v6H2zM22 9h-4v6h1.419A8.03 8.03 0 0 1 15 19.419V18h-5v4h2c5.523 0 10-4.477 10-10z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.873 12.926c-.019-.766.516-1.17 1.107-1.616.718-.542 1.52-1.147 1.52-2.542C15.5 7.154 14.215 6 12.09 6 9.996 6 8.5 7.266 8.5 9.394h2.068c0-1.016.573-1.572 1.523-1.572.852 0 1.37.445 1.37 1.099 0 .592-.44.927-.95 1.315-.697.531-1.524 1.162-1.524 2.69zM10.791 14.873c0 .599.517 1.127 1.132 1.127.629 0 1.146-.528 1.146-1.127 0-.625-.517-1.14-1.146-1.14-.615 0-1.132.515-1.132 1.14"
})));
export default SvgHelpline;